import api from "../axiosIntercepture";

export const getMenuBasedOnRole = async () => {
    try {
        const response = await api.post("global/get-menus",);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const getMenuBasedOnFacility = async (data) => {
    try {
        const response = await api.post("global/getifacilityMenu",data);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

/** POST { menuId: string[], tenantId: string, message?: string } — Bearer via axios interceptor. */
export const postModuleAccessRequest = async (body) => {
    try {
        const response = await api.post("global/module-access-request", body);
        return response.data;
    } catch (err) {
        throw err?.response?.data?.message ?? err?.message ?? "Module access request failed";
    }
};

/** GET pending/approved/rejected module access requests (SUPER_ADMIN). */
export const getModuleAccessRequests = async (status = "pending") => {
    try {
        const response = await api.get(`global/module-access-requests?status=${encodeURIComponent(status)}`);
        return response.data;
    } catch (err) {
        throw err?.response?.data?.message ?? err?.message ?? "Failed to load module access requests";
    }
};

/** PATCH review action for module access request (SUPER_ADMIN). */
export const reviewModuleAccessRequest = async (requestId, action, message) => {
    try {
        const response = await api.patch(
            `global/module-access-requests/${encodeURIComponent(requestId)}/review`,
            { action, message }
        );
        return response.data;
    } catch (err) {
        throw err?.response?.data?.message ?? err?.message ?? "Failed to review module access request";
    }
};

export const uploadFile = async (path, file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await api.post(`upload/${path}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (err) {
        const errorData = err?.response?.data;

        // If validation error with data array, throw the structured error
        if (errorData?.message === "Validation failed" && errorData?.data && Array.isArray(errorData.data)) {
            const validationError = new Error("Validation failed");
            validationError.isValidationError = true;
            validationError.validationData = errorData.data;
            validationError.originalResponse = errorData;
            throw validationError;
        }

        // For other errors, throw the message
        throw err?.response?.data?.message ;
    }
}

export const exportFile = async (path, selectedRows , dateRange, queryParams = {}) => {
    try {
        // Map known aliases to actual API paths
        const pathMap = {
            role: "auth/roles",
            SkuMaster : "item/AllItems",
            InventoryLedger : "item/InventoryLedger",
            ItemInventory : "item/ItemInventory"
        };

        // Use mapped path if available, else use the given path
        const apiPath = pathMap[path] || path;

        let finalObj = {};

        if (path === "InventoryLedger") {
            finalObj["startDate"] = dateRange.start;
            finalObj["endDate"] = dateRange.end
        }else{
            finalObj = selectedRows
        }
        

        console.log("selectedRows" , selectedRows);

        const query = new URLSearchParams(
            Object.entries(queryParams || {}).filter(([, value]) => value != null && value !== "")
        ).toString();
        const response = await api.post(`${apiPath}/export${query ? `?${query}` : ""}`, finalObj);

        return response.data?.message;
    } catch (err) {
        throw err?.response?.data?.message || "Export failed";
    }
};



export const downloadSampleFile = async (type) => {
    try {
        const response = await api.post(
            "global/downloadsample",
            { type },
            { responseType: "blob" }
        );

        const fileMap = {
            asn: "asn_sample.xlsx",
            "purchase-order": "purchase-order_sample.xlsx",
            salesorder: "salesorder_sample.xlsx",
            shipment: "shipment_sample.xlsx",
        };

        let fileName = fileMap[type] || "sample.xlsx";

        const disposition = response.headers["content-disposition"];
        if (disposition && disposition.includes("filename=")) {
            fileName = disposition
                .split("filename=")[1]
                .replace(/"/g, "")
                .trim();
        }

        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return fileName;
    } catch (err) {
        console.error("Download failed:", err);
        throw "Failed to download sample";
    }
};

